import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import BrandedListingContent from './BrandedListingContent';
import CadStockStatusLabel from '../../../Showroom/components/CadStockStatusLabel';
import { buildUnitPresentation } from '../../utils/listingPresentationUtils';
import { PUBLICATION_BLOCK_SX } from '../DockPanel/Tabs/formBlockUi';
import ListingVideoEmbeds from '../DockPanel/Tabs/ListingVideoEmbeds';
import ListingAttachments from '../DockPanel/Tabs/ListingAttachments';
import { colors, typography } from '../../../styles/theme';

/**
 * Detalle de unidad funcional en vistas compartidas (jerarquía marketplace).
 * Separado del formulario editable de DetailsTab.
 */
export default function BrandedUnitDetailSection({
  unit,
  lotContext = null,
  accentColor = null,
}) {
  const presentation = useMemo(
    () => buildUnitPresentation(unit, lotContext),
    [unit, lotContext],
  );

  if (!presentation) return null;

  const hasVisibleContent = Boolean(
    presentation.title
    || presentation.description
    || presentation.hero
    || presentation.metas.length > 0
    || presentation.images.length > 0
    || presentation.videos.length > 0
    || (presentation.attachments || []).length > 0,
  );
  if (!hasVisibleContent) return null;

  return (
    <Box sx={{ ...PUBLICATION_BLOCK_SX, p: 2 }}>
      <BrandedListingContent
        title={null}
        description={presentation.description}
        descriptionClamp={false}
        hero={presentation.hero}
        metas={presentation.metas.map((meta) => (
          meta.key === 'stock'
            ? { ...meta, value: <CadStockStatusLabel status={unit?.stock_status} /> }
            : meta
        ))}
        images={presentation.images}
        accentColor={accentColor}
      />
      {presentation.videos.length > 0 && (
        <Box sx={{ mt: presentation.images.length > 0 || presentation.hero || presentation.metas.length > 0 || presentation.description ? 1.5 : 0 }}>
          <Typography
            sx={{
              color: colors.textPanelTitle,
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              fontFamily: typography.fontFamily.primary,
              display: 'block',
              mb: 1.25,
              lineHeight: '16px',
            }}
          >
            Videos
          </Typography>
          <ListingVideoEmbeds videos={presentation.videos} />
        </Box>
      )}
      {(presentation.attachments || []).length > 0 && (
        <Box sx={{
          mt: (
            presentation.videos.length > 0
            || presentation.images.length > 0
            || presentation.hero
            || presentation.metas.length > 0
            || presentation.description
          ) ? 1.5 : 0,
        }}
        >
          <Typography
            sx={{
              color: colors.textPanelTitle,
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              fontFamily: typography.fontFamily.primary,
              display: 'block',
              mb: 1.25,
              lineHeight: '16px',
            }}
          >
            Adjuntos
          </Typography>
          <ListingAttachments attachments={presentation.attachments || []} />
        </Box>
      )}
    </Box>
  );
}
